import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { createRecord, uploadImage } from '../recordsApi';
import ImageDropZone from '../components/ImageDropZone';
import RecordForm from '../components/RecordForm';

export default function RecordNew() {
  const navigate = useNavigate();
  const [image, setImage] = useState(null);
  const [createdId, setCreatedId] = useState(null); // set once the record exists, so a retry only re-uploads the image

  const handleSave = async (values) => {
    let id = createdId;
    if (!id) {
      const record = await createRecord(values);
      id = record.DaftId__c;
      setCreatedId(id);
    }
    if (image) {
      try {
        await uploadImage(id, image);
      } catch (err) {
        throw new Error(`Listing ${id} was created, but the image upload failed: ${err.message}. Save again to retry the upload.`);
      }
    }
    navigate(`/listings/${encodeURIComponent(id)}`);
  };

  return (
    <div className="rec rec-page rec-narrow">
      <Link to="/listings" className="rec-btn rec-back">
        <span aria-hidden="true">←</span> Back to listings
      </Link>

      <RecordForm
        title="New listing"
        subtitle="Add a property manually"
        includeId
        media={<ImageDropZone file={image} onChange={setImage} />}
        cancelTo="/listings"
        saveLabel="Create listing"
        onSave={handleSave}
      />
    </div>
  );
}
